import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration (must be provided via environment variables)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY?.trim() as string,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN?.trim() as string,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID?.trim() as string,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET?.trim() as string,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID?.trim() as string,
  appId: process.env.REACT_APP_FIREBASE_APP_ID?.trim() as string,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID?.trim() as string
};

const missingFirebaseEnv = [
  ['REACT_APP_FIREBASE_API_KEY', firebaseConfig.apiKey],
  ['REACT_APP_FIREBASE_AUTH_DOMAIN', firebaseConfig.authDomain],
  ['REACT_APP_FIREBASE_PROJECT_ID', firebaseConfig.projectId],
  ['REACT_APP_FIREBASE_APP_ID', firebaseConfig.appId]
]
  .filter(([, v]) => !v)
  .map(([k]) => k);

if (missingFirebaseEnv.length > 0) {
  throw new Error(
    `Firebase env missing or empty: ${missingFirebaseEnv.join(', ')}. ` +
      'Add them to my-react-app/.env.local as KEY=value (one line per variable) and restart npm start. See .env.example.'
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = initializeFirestore(app, { ignoreUndefinedProperties: true });

// Initialize Analytics (only in browser, not in Node.js)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}
export { analytics };

export default app;

